import React from 'react';
import { TreeSelect } from 'antd';
import { CFormInput, CInputGroup, CInputGroupText } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilCloudDownload, cilTrash } from '@coreui/icons';

export default function WidgetAccountsSelectorVirtualized({
  data,
  value,
  onChange,
  reloadDropdownData,
  viewOnly,
  disabled = false,
  displayValue,
  showCloudIcon = true,
  showFormInputView = false,
  isMulti = false,
  labelInValue = false,
  height,
  width = '100%',
  dropdownMinWidth = 420,
}) {
  const renderFormInput = () => (
    <CInputGroup>
      <CFormInput value={displayValue} disabled />
      {!viewOnly && (
        <CInputGroupText
          style={{ cursor: 'pointer' }}
          onClick={() => onChange(isMulti ? [] : null, isMulti ? [] : null)}
        >
          <CIcon icon={cilTrash} alt="Remove" title="Remove" />
        </CInputGroupText>
      )}
    </CInputGroup>
  );

  const renderTreeSelect = () => (
    <CInputGroup style={{ height: 30 }}>
      <div style={{ flexGrow: 1 }}>
        <TreeSelect
          showSearch
          style={{ width: width, height: height }}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto', zIndex: 100000, minWidth: dropdownMinWidth }}
          getPopupContainer={() => document.body}
          dropdownMatchSelectWidth={false}
          placeholder="Please select"
          allowClear
          multiple={isMulti}
          labelInValue={labelInValue}
          treeCheckable={isMulti}
          showCheckedStrategy={TreeSelect.SHOW_ALL}
          onChange={(value, label) => onChange(value, label)}
          treeData={Array.isArray(data) ? data : []}
          value={isMulti ? (Array.isArray(value) ? value : []) : value}
          disabled={viewOnly || disabled}
          treeNodeFilterProp="title"
          virtual={true} // Enable virtualization
        />
      </div>
      {showCloudIcon && (
        <CInputGroupText
          style={{ cursor: viewOnly || disabled ? 'not-allowed' : 'pointer' }}
          onClick={() => {
            if (!viewOnly && !disabled) {
              reloadDropdownData()
            }
          }}
        >
          <CIcon icon={cilCloudDownload} alt="Remove" title="Remove" />
        </CInputGroupText>
      )}
    </CInputGroup>
  );

  return (
    <>
      {!isMulti && +value > 0 && displayValue !== '' && showFormInputView ? (
        <React.Fragment>{renderFormInput()}</React.Fragment>
      ) : (
        renderTreeSelect()
      )}
    </>
  );
}
